/* eslint-disable */

export function anchorSmooth() {
  $(document).on('click', 'a[href*="#"]', function (event) {
    if($(this).is('a[href^="#"]')) { //inside page
      if($($.attr(this, 'href')).length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top + (window.matchMedia("(min-width: 1280px)").matches ? -30 : -20)
        }, 500);
      }
    } else { //other/same page
      //same page
      if($.attr(this, 'href').replace(/#.*$/, '') == window.location.pathname) {
          if($($.attr(this, 'href').replace(/.+(#.*$)/, '$1')).length) {
            event.preventDefault();
            $('html, body').animate({
              scrollTop: $($.attr(this, 'href').replace(/.+(#.*$)/, '$1')).offset().top + (window.matchMedia("(min-width: 1280px)").matches ? -30 : -20)
            }, 500);
          }
      } else {
        //other page.
      }
    }
  });

  $( window ).on('load', function(){
    //anchorSmooth from hash?
    if(window.location.hash) {
      var hash = window.location.hash;
      if( $(hash).length) {
        setTimeout(function(){
          $('html, body').animate({
            scrollTop: $(hash).offset().top + (window.matchMedia("(min-width: 1280px)").matches ? -30 : -20)
          }, 500);
        }, 500);
      }
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/util/anchorSmooth.js